export const VolunteerRegistrationSelector = ({
  volunteerRegistrationStore: { VolunteerRegistrationData }
}) => VolunteerRegistrationData;
export default VolunteerRegistrationSelector;

export const VolunteerCountriesListSelector = ({
  volunteerRegistrationStore: { CountriesList }
}) => CountriesList;
